import { Route, Routes } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { useUserStore } from './stores/user-store';
import useAuth from './auth/useAuth';
import { UserRole } from './types/server-types/UserRole';
import Layout from './components/Layout';
import DashboardPage from './components/pages/DashboardPage';
import { Loader2 } from 'lucide-react'
import LoginPage from './components/pages/LoginPage';

const App = () => {
    const { authIsLoading, isAuthenticated, roles } = useAuth();

    const { role } = useUserStore(
        useShallow((state) => ({
            role: state.user?.role
        }))
    );

    if (authIsLoading) {
        return (
            <div className='w-screen h-screen flex justify-center items-center'>
                <Loader2 className='w-16 h-16 text-primary-400 animate-spin' />
            </div>
        )
    }

    return isAuthenticated ? (
        <Routes>
            {(role === UserRole.ADMIN || role === UserRole.OPERATOR || role === UserRole.USER) ? (
                <Route element={<Layout />}>
                    <Route element={<DashboardPage />} path='/' />
                </Route>
            ) : (
                <Route element={<Layout />}>
                    <Route element={<LoginPage />} path='' />
                    <Route element={<LoginPage />} path='*' />
                </Route>
            )}
        </Routes>
    ) : (
        <Routes>
            <Route element={<Layout />}>
                <Route element={<LoginPage />} path='' />
                <Route element={<LoginPage />} path='*' />
            </Route>
        </Routes>
    );
};

export default App;
